/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Composer_LabelInputs */



/**
* | output |
* | --- |
* | "Message the AI Assistant" |
*
* @param {Assistant_Composer_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_composer_label = /** @type {((inputs?: Assistant_Composer_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Composer_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer un message à l'assistant IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nachricht an den KI-Assistenten senden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia un messaggio all'assistente IA")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Напишите сообщение ИИ-помощнику")
	if (locale === "es") return /** @type {LocalizedString} */ ("Envía un mensaje al asistente de IA.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("给人工智能助手发送消息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIアシスタントにメッセージを送る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई सहायक को संदेश भेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Envie uma mensagem ao assistente de IA.")
	return /** @type {LocalizedString} */ ("Message the AI Assistant")
});